import { render, staticRenderFns } from "./WarningCalloutAlt.vue?vue&type=template&id=10113cb3&"
import script from "./WarningCalloutAlt.vue?vue&type=script&lang=js&"
export * from "./WarningCalloutAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports